import React from 'react';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import { injectIntl, FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import { Button, Form, FieldSelect, UnsavedInfoPrompt } from '../../components';
import ReactTooltip from 'react-tooltip';
import css from './SignUpProjectForms.css';

export const EditProjectListingBudgetDurationFormComponent = props => (
  <FinalForm
    {...props}
    render={formRenderProps => {
      const {
        className,
        disabled,
        ready,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        previousActionMsg,
        updated,
        updateInProgress,
        fetchErrors,
        dirty,
        onPrev,
      } = formRenderProps;

      const translationKey = 'EditProjectListingBudgetForm.pricePerUnit';

      const pricePerUnitMessage = intl.formatMessage({
        id: translationKey,
      });

      const projectDurationTitle = intl.formatMessage({
        id: 'EditProjectListingBudgetForm.projectDurationTitle',
      });

      const budgetInfoText = intl.formatMessage({
        id: 'EditProjectListingBudgetForm.budgetInfoText',
      });

      const priceEstimatePlaceholderMessage = intl.formatMessage({
        id: 'EditProjectListingBudgetForm.priceEstimatePlaceholder',
      });

      const durationProjectLabel = intl.formatMessage({
        id: 'EditProjectListingBudgetForm.projectDurationProject',
      });
      const durationContinuousLabel = intl.formatMessage({
        id: 'EditProjectListingBudgetForm.projectDurationContinuous',
      });

      const projectTierTitle = intl.formatMessage({
        id: 'EditProjectListingRequirementsForm.projectTierTitle',
      });

      const projectTier1 = intl.formatMessage({
        id: 'EditProjectListingRequirementsForm.projectTier1',
      });

      const projectTier2 = intl.formatMessage({
        id: 'EditProjectListingRequirementsForm.projectTier2',
      });

      const projectTier3 = intl.formatMessage({
        id: 'EditProjectListingRequirementsForm.projectTier3',
      });

      const projectTier35 = intl.formatMessage({
        id: 'EditProjectListingRequirementsForm.projectTier35',
      });

      const projectTier4 = intl.formatMessage({
        id: 'EditProjectListingRequirementsForm.projectTier4',
      });

      const projectUrgencyTitle = intl.formatMessage({
        id: 'EditProjectListingBudgetForm.projectUrgencyTitle',
      });

      const projectUrgencyUrgent = intl.formatMessage({
        id: 'SearchFilters.urgencyUrgent',
      });

      const projectUrgencyWithingAWeek = intl.formatMessage({
        id: 'SearchFilters.urgencyWithinAWeek',
      });

      const projectUrgencyWithinAMonth = intl.formatMessage({
        id: 'SearchFilters.urgencyWithinAMonth',
      });

      const projectUrgencyNotUrgent = intl.formatMessage({
        id: 'SearchFilters.urgencyNotUrgent',
      });

      const classes = classNames(css.root, className);
      const submitReady = (updated && pristine) || ready;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;
      const { updateListingError, showListingsError } = fetchErrors || {};

      return (
        <Form onSubmit={handleSubmit} className={classes}>
          {updateListingError ? (
            <p className={css.error}>
              <FormattedMessage id="EditProjectListingBudgetForm.updateFailed" />
            </p>
          ) : null}
          {showListingsError ? (
            <p className={css.error}>
              <FormattedMessage id="EditProjectListingBudgetForm.showListingFailed" />
            </p>
          ) : null}
          {typeof window === 'object' ? <ReactTooltip /> : null}
          <label htmlFor="projectDuration" className={css.projectDurationTitle}>
            {projectDurationTitle}
          </label>
          <FieldSelect
            id="projectDuration"
            name="projectDuration"
            className={css.projectDuration}
            validate={validators.required(projectDurationTitle)}
          >
            <option disabled value="">
              {projectDurationTitle}
            </option>
            <option value="project">{durationProjectLabel}</option>
            <option value="continuous">{durationContinuousLabel}</option>
          </FieldSelect>
          <label htmlFor="projectUrgency" className={css.projectUrgencyTitle}>
            {projectUrgencyTitle}
          </label>
          <FieldSelect
            id="projectUrgency"
            name="projectUrgency"
            className={css.projectUrgency}
            validate={validators.required(projectUrgencyTitle)}
          >
            <option disabled value="">
              {projectUrgencyTitle}
            </option>
            <option value="urgent">{projectUrgencyUrgent}</option>
            <option value="within_a_week">{projectUrgencyWithingAWeek}</option>
            <option value="within_a_month">{projectUrgencyWithinAMonth}</option>
            <option value="not_urgent">{projectUrgencyNotUrgent}</option>
          </FieldSelect>
          <label htmlFor="projectTier" className={css.projectTierTitle}>
            {projectTierTitle}
          </label>
          <FieldSelect
            id="projectTier"
            name="projectTier"
            className={css.projectTier}
            validate={validators.required(projectTierTitle)}
          >
            <option disabled value="">
              {projectTierTitle}
            </option>
            <option value="all">{projectTier1}</option>
            <option value="entry">{projectTier2}</option>
            <option value="junior">{projectTier3}</option>
            <option value="midlevel">{projectTier35}</option>
            <option value="senior">{projectTier4}</option>
          </FieldSelect>
          <label htmlFor="priceEstimate" className={css.priceEstimateTitle}>
            {pricePerUnitMessage}
          </label>
          <FieldSelect
            id="priceEstimate"
            name="priceEstimate"
            className={css.priceEstimate}
            validate={validators.required(priceEstimatePlaceholderMessage)}
          >
            <option disabled value="">
              {priceEstimatePlaceholderMessage}
            </option>
            <option value="0-1 000 €">0-1000 €</option>
            <option value="1 000-3 000 €">1000-3000 €</option>
            <option value="3 000-5 000 €">3000-5000 €</option>
            <option value="5 000-10 000 €">5000-10000 €</option>
            <option value="10 000 € +">10000 € +</option>
          </FieldSelect>
          <div className={css.budgetInfoText}>{budgetInfoText}</div>

          <div className={css.buttonContainer}>
            <Button className={css.previousButton} onClick={onPrev}>
              {previousActionMsg}
            </Button>
            <Button
              className={css.submitButton}
              type="submit"
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </Button>
          </div>

          <UnsavedInfoPrompt when={dirty} />
        </Form>
      );
    }}
  />
);

export default compose(injectIntl)(EditProjectListingBudgetDurationFormComponent);
